import generateAlphaId from '../../common/helpers/generate-alpha-id';

const generateUniqueFontPairId = (baseId) => `${baseId}-${generateAlphaId()}`;

export default generateUniqueFontPairId;
